import { memo } from 'react';
import cn from 'classnames';
import { useAsync } from 'react-use';
import { ArrayUtils, StringUtils } from 'src/utils';
import { CommonService } from 'src/services';
import { Element } from 'src/components';
import RouterLink from 'src/components/links';
import { IGold } from '@zmedia/bm-common/modules';

export function GoldBox() {
    const state = useAsync(CommonService.getGoldList);
    const data = state.value?.data || {};
    const boards: IGold[] = data?.boards || [];

    if (ArrayUtils.isEmpty(boards)) {
        return null;
    }
    const info = boards[1]?.lastUpdateTime.split(' ');

    return (
        <RouterLink
            to="/tien-ich-gia-vang.epi"
            className={cn(
                'relative',
                'border-[#EFE6AB] border border-solid',
                'rounded-[4px]',
                'w-[210px]',
                "bg-[url('https://baomoi-static.bmcdn.me/web/styles/img/gold-bg.png')]",
                'bg-cover',
                'bg-center',
                'px-[16px] pt-[18px] pb-[6px]',
                'block',
                'shrink-0'
            )}
        >
            <Element className="flex justify-between">
                <Element className="text-[#554300] text-[10px] font-[800] leading-[1.6] shrink-0">
                    Giá vàng
                    <Element className="text-[#1A1A1A] text-[18px] font-[900] leading-[1.2]">
                        SJC
                    </Element>
                </Element>
                <Element
                    className={cn(
                        'flex items-center flex-col',
                        'text-[rgba(0,0,0,0.6)]',
                    )}
                >
                    {boards[0]?.entries?.[0] && (
                        <>
                            <Element className="text-[13px] flex whitespace-nowrap">
                                <Element className='font-bold'>Mua:&nbsp;</Element>
                                <Element className="font-[900] text-[#131214]">
                                    {StringUtils.numberWithCommas(
                                        boards[0]?.entries[0].buy,
                                    )}
                                </Element>
                            </Element>
                            <Element className="text-[13px] flex whitespace-nowrap mt-[3px]">
                                <Element className='font-bold'>Bán:&nbsp;</Element>
                                <Element className="font-[900] text-[#131214]">
                                    {StringUtils.numberWithCommas(
                                        boards[0]?.entries[0].sell,
                                    )}
                                </Element>
                            </Element>
                        </>
                    )}
                </Element>
            </Element>
            <Element className="text-right text-[8px] text-[#666] mt-[2px] leading-[1]">
                Cập nhật lúc: {info[1].replace(/:/g, 'h')} ngày{' '}
                {info[0].replace(/-/g, '/')}
            </Element>
        </RouterLink>
    );
}

export default memo(GoldBox);
